import { Component, Inject} from '@angular/core';
import { DeviceContextService } from 'sspapp/services/device-context.service';
import { SspAuthorizationService } from 'sspservices/ssp-authorization.service';

@Component({
  selector: 'ssp-enroll-page',
  templateUrl: './enroll-page.component.html',
  styleUrls: ['./enroll-page.component.scss']
})
export class EnrollPageComponent {  

  enrollmentLink: string;
  hasDevices: boolean = false;
  enrollmentId: string = "";

  constructor(
    private deviceContextService: DeviceContextService,
    private AuthSvc: SspAuthorizationService
    )
    {
      this.deviceContextService.reloadDevicesSsp().finally(()=> {
        this.hasDevices =  (Object.keys( this.deviceContextService.devices).length > 0);
      })
      //TODO: migrate the SSP service and retrieve the dmaUrl from MobiControl
      this.enrollmentLink = "https://" + window.location.host + '/enrollment';
  }

  onLogout = () =>{
    this.AuthSvc.logout();
  }
}